import type { Vector2Tuple } from 'three';

import type { PCDData } from '@/type';

export const KEYS = {
  STORAGE_PCD_BASE_PATH_LIST: 'STORAGE_PCD_BASE_PATH_LIST',
};

export const EMPTY_PCD_DATA: PCDData = {
  pointList: new Float32Array(),
  zRange: [0, 10],
};

export const DEFAULT_Z_RANGE = [-Infinity, Infinity] as Vector2Tuple;
